<div class="space-y-2">
  <div class="grid grid-cols-2 text-sm">
    <div class="font-semibold">{{ appStore.location().name | titlecase }}</div>
    <div class="text-right">Date: {{ date }}</div>
    <div class="font-semibold">{{ appStore.location().phone | formatPhone }}</div>

    @if (appStore.cart().repair_order?.repair_order_number) {
      <div class="text-right">RO #: {{ appStore.cart().repair_order?.repair_order_number }}</div>
    }

    @if (appStore.cart().repair_order?.customer_name; as customerName) {
      <div>Customer: <span class="font-semibold">{{customerName | titlecase}}</span></div>
    }

    @if (vehicle()) {
      <div class="text-right">Vehicle: <span class="font-semibold">{{vehicle()}}</span></div>
    }

    <div></div>
  </div>
</div>
